<template>
  <div class="sr-sub-title">
     <img :src="titleIcon" />
    <h5>{{title}}</h5>
  </div>
</template>

<script>

export default {
  name: "SrSubTitle",
  components: {},
  props: {
    title: String
  },
  data() {
    return {
      titleIcon: require('../theme-chalk/src/images/icon-title.png'),
    };
  },
  methods: {
  },
};
</script>



// WEBPACK FOOTER //
// packages/SrSubTitle/index.vue